/* eslint-disable no-console */


var internalThis;

export default class okanMain{
    constructor(context){
        this.context = context;

        this.imagePrefix = "./img/";

        this.orientation = null;
        this.isMobile = this.mobileCheck();

        this.data = [];
        this.pages = [];
        this.shortcuts = []; //stockage des mots spécifiques : Saint = St = Ste = S. .....
        this.currentPage = 0;
        this.maxPageReached = 0;
        
        this.start = null;
        this.maxScore =0;
        this.score = 0;
        this.scoreReduced = true;
        this.scoreToAdd = 0;
        this.elapsed = 0;

        this.popup = null;
        this.answerSeparatorChar = "|";
        this.key = null; // clé unique pour pouvoir faire plusieurs jeux dans une même journée

        internalThis = this;
    }

    gotoPage(){
        
    }

    resize(){
        internalThis.mobileCheck(); //orientation test
    }

    init(){
        this.loadJson('data/data.json', (response)=>{
            this.data= JSON.parse(response);
            //console.log("aaa",this.data);
            this.data.forEach(element => {
                if(this.pages.indexOf(element.idPage) == -1)
                    this.pages.push(element.idPage);
                if(element.type =='question' || element.type == 'qcm')
                    this.maxScore += Number(element.value2); 
            });
        });

        this.loadJson('data/shortcuts.json', (response)=>{
            this.shortcuts = JSON.parse(response);
        });

        this.loadJson('data/key.json', (response)=>{
            this.key = JSON.parse(response).key + "_";
            this.checkCookie();
        })

        
    }

    getElements(pageId){
        var result = [];
        this.data.forEach(element =>{
            if(element.idPage == pageId)
                result.push(element);
        });
        return result;
    }

    loadJson(jsonUrl, callback){
        var xhr = new XMLHttpRequest();
        xhr.open("POST", jsonUrl, true);
       //xhr.setRequestHeader("Access-Control-Allow-Origin" , "*");
        xhr.setRequestHeader("Content-Type", "application/json");
        
        xhr.onreadystatechange = function() { 
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                console.log("response", xhr);
                callback(this.response);
            }
        }
        xhr.send(null);        
    }

    mobileCheck(){
        let check = false;
        //eslint-disable-next-line
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
       // console.log("check", check);

        if (!check){
            this.orientation = null;
            return false;
        }
            
        var isIOS = function(){
            return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
              ].includes(navigator.platform)
              // iPad on iOS 13 detection
              || (navigator.userAgent.includes("Mac") && "ontouchend" in document)            
        }
        
        var checkIOS =  isIOS();

        if(checkIOS){
            if (Math.abs(window.orientation) === 90) {
                this.orientation = "landscape";
            } else {
                this.orientation = "portrait";
            }            
        }
        else{
            var orientation = screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type;
            if(orientation.includes('landscape'))
                this.orientation = "landscape";
            else
                this.orientation = "portrait";            
        }
        return true;
    }    

    formatResponse(response){
        var retour = response.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        retour = retour.replace(/-/g,' ');
        retour = retour.replace(/\./g,' ');
        retour = retour.replace(/\s+/g, " ");
        retour = retour.toLowerCase();
        retour = retour.trim();

        //console.log(retour);
        return retour;
    }

    checkForAnswer(element, response){
       console.log("answers ", element.value)
        var answers = element.value.split(this.answerSeparatorChar);
        var retour = false;
        answers.forEach(answer => {
            if(!retour){
                if(response.indexOf(answer.trim()) >= 0)
                    retour = true;
            }
        });
        //console.log("check4answer", retour);
        return retour;
    }

    CheckForSpecialChars(element, response){
        console.log('im here')
        var hasSpecialChar = false;
        var shorts = [];
        var answers = element.value.split(this.answerSeparatorChar);
        this.shortcuts.forEach(short => {
            if(element.value.indexOf(short.id) >= 0){
                hasSpecialChar = true;
                shorts.push(short);
            }
        });
        console.log("special char : ", hasSpecialChar)
        if(hasSpecialChar){
            if(this.checkForAnswer(element, this.formatResponse(response))){
                return true;
            }
            else{
                var found = false;
                shorts.forEach(short => {
                    short.entries.forEach(entry => {
                        var tmpString = response;
                        var tmpRoot = "";
                        var index = 0;
                        while((index = tmpString.indexOf(entry)) > -1){
                            var newEntry = tmpRoot + tmpString.substring(0,index) + short.id + tmpString.substring(index + entry.length);
                            tmpRoot += tmpString.substring(0,index + entry.length);
                            tmpString = tmpString.substring(index + entry.length);
                           // console.log('will add : ', newEntry);
                            answers.forEach(answer => {
                                /*console.log('will compare :', '$' + this.formatResponse(newEntry) + '$');
                                console.log('with :', '$' + answer.trim() + '$');
                                console.log('result : ',  this.formatResponse(newEntry).indexOf(answer.trim()) )*/
                                if(this.formatResponse(newEntry).indexOf(answer.trim()) >= 0){
                                   // console.log("get it")
                                    found = true;
                                    return true;
                                }  
                            });
                        }                  
                    });
                });
                return found;
            }
        }else{
            return this.checkForAnswer(element, this.formatResponse(response));
        }
    }



    /***********************************************************************************
    ************            Cookies                     ********************************
    ************************************************************************************/

    setCookie(cname, cvalue){
        var d = new Date();

        d.setTime(d.getTime() + (24*60*60*1000)); // 1 day life
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";        
    }

    getCookie(cname){
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";        
    }

    checkCookie(){
        var current = this.getCookie(this.key + "current");
        if (current != "") {
            this.currentPage = current;
            this.score = parseInt(this.getCookie(this.key + "score"));
            this.start = this.getCookie(this.key + "start");
            this.elapsed = this.getCookie(this.key + "elapsed");
        } else {
            this.start= new Date();
            this.setCookie(this.key + "current", this.currentPage);
            this.setCookie(this.key + "start", this.start);
            this.setCookie(this.key + "score", this.score);
            this.setCookie(this.key + "elapsed", this.elapsed);
        }
    }

    deleteCookie(){
        document.cookie = this.key + "start=; ";  
        document.cookie += this.key + "current=; ";
        document.cookie += this.key + "score=; ";
        document.cookie += this.key + "elapsed=; ";

        document.cookie += "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    updateCookie(){
        this.setCookie(this.key + "current", this.currentPage);
        this.setCookie(this.key + "score", this.score);
    }
}